import * as DRAFT_REGISTRATION_ACTION_TYPE from "./actionTypes";

export const initialState = {
    draftList: [],
    deleteItem: null,
    deletePopup: {
        title: "",
        description: "",
        buttonText: "",
        showPopup: false,
        confirm: false,
    },
    clickIds: [],
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case DRAFT_REGISTRATION_ACTION_TYPE.UPDATE_DELETE_POPUP: {
            return { ...state, deletePopup: { ...action.payload } };
        }
        case DRAFT_REGISTRATION_ACTION_TYPE.FETCH_DRAFT_WARRANTY_LIST_SUCCESS: {
            return { ...state, draftList: action.value, deleteItem: null };
        }
        case DRAFT_REGISTRATION_ACTION_TYPE.DELETE_DRAFT_WARRANTY_ITEM_SUCCESS: {
            return { ...state, deleteItem: action.value };
        }
        case DRAFT_REGISTRATION_ACTION_TYPE.ADD_DASHBOARD_CLICK_ELEMENTS: {
            return { ...state, clickIds: action.id === "" ? [] : [...state.clickIds, action.id] };
        }
        default:
            return state;
    }
};

export default reducer;
